import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { fileUrl } from "@/lib/api";
import { usePlayer } from "@/context/PlayerContext";
import TrackRow from "@/components/TrackRow";
import { Button } from "@/components/ui/button";
import { Play, ArrowLeft } from "lucide-react";

export default function AlbumPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [album, setAlbum] = useState(null);
  const { playTrack } = usePlayer();

  useEffect(() => {
    api.get(`/albums/${id}`).then((r) => setAlbum(r.data)).catch(() => setAlbum(false));
  }, [id]);

  if (album === null) return <div className="p-12 text-muted-foreground overline text-sm">LOADING...</div>;
  if (album === false) return <div className="p-12 text-muted-foreground">Album not found.</div>;

  const cover = fileUrl(album.cover_file_id);
  const tracks = album.tracks || [];

  return (
    <div>
      <button data-testid="back-btn" onClick={() => nav(-1)} className="flex items-center gap-2 px-6 md:px-12 pt-8 text-muted-foreground hover:text-white transition-colors text-xs overline">
        <ArrowLeft size={16} /> Back
      </button>
      <section className="px-6 md:px-12 py-8 flex flex-col md:flex-row gap-8 items-start border-b border-border">
        <div className="w-full max-w-xs aspect-square bg-secondary border border-border block-shadow overflow-hidden shrink-0">
          {cover ? <img src={cover} alt={album.title} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center font-display text-6xl text-white/20">{album.title?.[0]}</div>}
        </div>
        <div className="flex-1">
          <div className="overline text-xs text-accent mb-2">Album</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[0.95] mb-3">{album.title}</h1>
          <div className="text-muted-foreground mb-1">{album.artist}{album.year ? ` · ${album.year}` : ""}</div>
          <div className="text-sm text-muted-foreground mb-6">{tracks.length} tracks</div>
          {album.description && <p className="text-sm text-muted-foreground max-w-lg mb-6">{album.description}</p>}
          {tracks.length > 0 && (
            <Button data-testid="album-play-all" onClick={() => playTrack(tracks[0], tracks)} className="bg-primary hover:bg-white hover:text-primary rounded-none font-bold overline text-sm h-12 px-8">
              <Play size={18} className="mr-2" /> Play Album
            </Button>
          )}
        </div>
      </section>
      <section className="px-6 md:px-12 py-8">
        {tracks.length === 0 ? (
          <div className="border-2 border-dashed border-border p-12 text-center text-muted-foreground text-sm">No tracks in this album yet.</div>
        ) : (
          <div className="border-t border-border">
            {tracks.map((t, i) => <TrackRow key={t.id} track={t} index={i} list={tracks} />)}
          </div>
        )}
      </section>
    </div>
  );
}
